<!-- 手机端 邀请用户 -->
<template>
  <div class="phone">
    <div class="card">
      <div class="card_title">
        <div class="compName">
          {{ companyname }}
          <span class="name_bg"></span>
        </div>
        <div class="title_msg" v-if="active != 3">
          正在注册太行用户管理中心。
        </div>
      </div>
      <div class="center">
        <div v-if="active == 1">
          <div class="LoginPhone">
            <div class="input">
              <div class="input_name">
                <span class="Required">*</span>手机号
              </div>
              <el-input
                v-model="phonenumber"
                placeholder="必填"
                @input="phonenumberinputChange"
              ></el-input>
            </div>
            <div class="input">
              <div class="input_name">
                <span class="Required">*</span>验证码
              </div>
              <el-input
                v-model="pohoneCode"
                maxlength="6"
                placeholder="必填"
                class="name_getcode"
              >
                <template slot="append">
                  <div class="input_name_in" @click="getCode" v-if="!count">
                    获取验证码
                  </div>
                  <div class="input_name_in" v-if="count">
                    {{ count }}秒后重发
                  </div>
                </template>
              </el-input>
            </div>
          </div>
          <div class="bottom_botton">
            <div class="next_no" v-if="!pohoneCode || !phonenumber">下一步</div>
            <div
              class="next"
              @click="nexType(1)"
              v-if="phonenumber && pohoneCode"
            >
              下一步
            </div>
          </div>
        </div>
        <div v-if="active == 2">
          <div class="LoginPhone">
            <div class="input">
              <div class="input_name"><span class="Required">*</span>姓名</div>
              <el-input
                v-model="userName"
                placeholder="请输入真实姓名"
              ></el-input>
            </div>
            <div class="input">
              <div class="input_name">账号</div>
              <el-input v-model="account" placeholder="请输入账号"></el-input>
            </div>
            <div class="input">
              <div class="input_name"><span class="Required">*</span>密码</div>
              <el-input v-model="passworld" placeholder="请输入密码"></el-input>
            </div>
            <div class="input">
              <div class="input_name">身份证号</div>
              <el-input v-model="idCard" placeholder="请输入身份证号"></el-input>
            </div>
          </div>
          <div class="bottom_botton">
            <div class="next_no" v-if="!userName || !passworld">下一步</div>
            <div class="next" @click="nexType(2)" v-if="userName && passworld">
              下一步
            </div>
            <div class="back" @click="active = 1">返回上一步</div>
          </div>
        </div>
        <div v-if="active == 3" class="center_card">
          <img
            class="img_sess"
            src="../../../assets/IMG/userManagement/addlink.png"
            alt=""
          />
          <div class="sess_msg">您已完成注册并成功加入公司！</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  phoneverifyCode,
  usercheckPhone,
  createUserOrCompany,
} from "../../../api/api";
import { checkPhone, checkIdcardPattern } from '@/utils/tools';

export default {
  name: "memberMobile",
  props: ["createBy", "companyname", "deptId", "info"],
  data() {
    return {
      phonenumber: "", //手机号
      pohoneCode: "", //验证码
      userName: "", //用户名
      account: "", //账号
      passworld: "", //密码
      idCard: '', // 身份证号码
      timer: null,
      count: null,
      active: 1,
    };
  },

  methods: {
    /**
     * 点击获取验证码
     * */

    getCode() {
      if (checkPhone(this.phonenumber)) {
        let params = {
          phone: this.phonenumber,
          type: "Register",
        };
        phoneverifyCode(params).then((res) => {
          if (res.code == 200) {
            this.countdown();
          }
        });
      } else {
        this.$notify.error({
          title: "错误",
          message: "手机号输入有误，请重新输入！",
        });
      }
    },

    /**
     * 60秒倒计时，验证码请求成功后开始
     * */

    countdown() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count -= 1;
          } else {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },

    /**
     * 电话号码输入只能输入数字
     * */

    phonenumberinputChange(val) {
      this.phonenumber = this.phonenumber.replace(/[^0-9.]/g, "");
    },

    /**
     * 点击下一步
     * */
    nexType(data) {
      if (data == 1) {
        let params = {
          phone: this.phonenumber,
          code: this.pohoneCode,
          deptId: this.$props.deptId,
        };
        usercheckPhone(params).then((res) => {
          if (res.data == 1) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
            this.active = data + 1;
          } else if (res.data == 2) {
            this.active = 3;
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
          } else if (res.code == 6006) {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            });
          }
        });
      } else if (data == 2) {
        if (this.idCard && !checkIdcardPattern(this.idCard)) {
          this.$notify.error({
            title: "错误",
            message: "请输入正确的身份证号码！",
          })
          return
        }
        let params = {
          companyName: this.companyname,
          userName: this.account,
          nickName: this.userName,
          phone: this.phonenumber,
          password: this.passworld,
          idCard: this.idCard,
          createBy: this.createBy,
          deptId: this.deptId,
          ...this.info,
        };
        createUserOrCompany(params).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: "成功",
              message: res.msg,
            });
            this.active = data + 1;
          } else {
            this.$notify.error({
              title: "失败",
              message: res.msg,
            });
          }
        });
      } else {
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input,
input:focus,
textarea,
textarea:focus,
select,
select:focus {
  font-size: 16px !important;
}

.LoginPhone :deep(.el-input-group__append, .el-input-group__prepend) {
  background-color: #fff !important;
  color: #b7282d;
}

.LoginPhone
  :deep(.el-input-group__append:focus, .el-input-group__prepend:focus) {
  user-select: none !important;
  cursor: pointer !important;
}
.phone {
  height: 100vh;
  width: 100%;
  background: url("../../../assets/IMG/registration/phone_bg.png") no-repeat;
  background-size: 100%;
  background-color: #f5f5f5;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  .card {
    box-shadow: 0rem 0.1875rem 0.375rem rgba(0, 0, 0, 0.1);
    border-radius: 0.75rem;
    width: 21.4375rem;
    height: 34.4375rem;

    margin-bottom: 2rem;
    padding: 2rem;
    box-sizing: border-box;
    background: url("../../../assets/IMG/login/bg_ele.png") no-repeat;
    background-size: 100%;
    background-position: bottom;
    background-color: #fff;
    .card_title {
      .compName {
        display: inline-flex;
        flex-direction: column;
        font-size: 1.0625rem;
        font-weight: 600;
        color: #b7282d;
        position: relative;
        .name_bg {
          position: absolute;
          width: 100%;
          left: 0;
          bottom: 0;
          height: 13px;
          background: rgba(183, 40, 45, 0.1);
        }
      }
      .title_msg {
        font-size: 9px;
        margin-top: 0.375rem;
      }
    }

    .center {
      margin-top: 3rem;
      .LoginPhone {
        width: 100%;
        .title {
          font-weight: 400;
          font-size: 1.25rem;
          line-height: 1.75rem;
          color: #333333;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 3.75rem;
        }
        .input {
          position: relative;
          padding: 1.25rem 0 0.625rem 0;
          .input_name {
            z-index: 5;
            position: absolute;
            color: #999999;
            font-weight: 400;
            font-size: 1rem;
            line-height: 1.375rem;
            background: #fff;
            left: 5%;
            top: 0.375rem;
          }

          .input_name_in {
            width: 100%;
            height: 100%;
            user-select: none;
            cursor: pointer;
          }
        }

        .erro {
          user-select: none;
          font-weight: 400;
          font-size: 0.75rem;
          line-height: 1.0625rem;
          color: #f84638;
        }

        .login_button {
          user-select: none;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 3.75rem;

          .button {
            margin-right: 10px;
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            background: #b7282d;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          .button_no {
            cursor: pointer;
            width: 4rem;
            height: 2rem;
            background: #ccc;
            border-radius: 0.25rem;
            color: #ffffff;
            font-size: 0.75rem;
            line-height: 1.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
        .suss_msg {
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 400;
          font-size: 1.625rem;
          line-height: 2.25rem;
          color: #333333;
        }
        .avatar-uploader {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .avatar-uploader .el-upload {
          cursor: pointer;
          position: relative;
          overflow: hidden;
        }
        .avatar-uploader-icon {
          font-size: 1.75rem;
          color: #8c939d;
          width: 5.5rem;
          height: 5.5rem;
          line-height: 5.5rem;
          text-align: center;
          border: 0.0625rem dashed #ccc;
          border-radius: 0.375rem;
        }
        .avatar {
          width: 5.5rem;
          height: 5.5rem;
          display: block;
        }
      }
    }
    .center_card {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .img_sess {
        width: 8.0625rem;
        height: 7.9375rem;
      }
      .sess_msg {
        color: #333333;
        font-weight: 400;
        font-size: 0.9375rem;
        margin-top: 1.5rem;
        text-align: center;
      }
    }

    .bottom_botton {
      margin-top: 4.375rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .next {
        width: 17.4375rem;
        height: 2.3125rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.1875rem;
        background-color: #b7282d;
        color: #fff;
        font-size: 0.9375rem;
      }

      .back {
        font-weight: bold;
        font-size: 0.9375rem;
        color: #b7282d;
        text-decoration: underline;
        margin-top: 1rem;
      }
      .next_no {
        width: 17.4375rem;
        height: 2.3125rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 1.1875rem;
        background-color: #e5e5e5;
        color: #999;
        font-size: 0.9375rem;
      }
    }
  }
}
</style>